import React, { useState, useCallback, useEffect } from "react";
import "./ContactUs.css";
// import Header from "../Common/Header";
import Icons from "../../../../Config/Images";
import Section4 from "../PartnersScreen/Section4";
import { useDispatch, useSelector } from "react-redux";
import { addContactUsUrl } from "../../../../Store/Action/menu";
import { toast } from "react-toastify";
import { getPageWithSlugAPI } from "../../../../Store/Action/page";
import { BASE_URL, pageSlug } from "../../../../Constants/AppConstants";
import Header from "../../Layout/Header/Header";
import HeaderBlack from "../Common/Header";
import { useLocation, useNavigate } from "react-router-dom";
import CustomLoader from "../../CustomComponents/CustomLoader/CustomLoader";
import Footer from "../../Layout/Footer/Footer";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";

// const ContactInfo = ({ icon, title, info }) => {
//   // Check if the title is related to email, phone, WhatsApp, or Address
//   const isEmail = title?.toLowerCase().includes("email");
//   const isWhatsApp = title?.toLowerCase().includes("whatsapp");
//   const isPhone = title?.toLowerCase().includes("call");
//   const isAddress = title?.toLowerCase().includes("address");

//   return (
//     <div className="inner-card">
//       {/* Left side - Icon and Title */}
//       <div className="inner-card-left">
//         <img src={icon ? icon : Icons.default_image} alt={`${title} icon`} />
//         <p className="call-us-para">{title}</p>
//       </div>

//       {/* Right side - Clickable links for Email, Phone, WhatsApp, and Address */}
//       <div className="inner-card-right">
//         {isEmail ? (
//           <a
//             href={`mailto:${info}`}
//             style={{ textDecoration: "none", color: "inherit" }}
//           >
//             <p className="num-para">{info}</p>
//           </a>
//         ) : isWhatsApp ? (
//           <a
//             href={`https://wa.me/${info}`}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ textDecoration: "none", color: "inherit" }}
//           >
//             <p className="num-para">{info}</p>
//           </a>
//         ) : isPhone ? (
//           <a
//             href={`tel:${info}`}
//             style={{ textDecoration: "none", color: "inherit" }}
//           >
//             <p className="num-para">{info}</p>
//           </a>
//         ) : isAddress ? (
//           <a
//             // href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//             //   info
//             // )}`}
//             href="https://www.google.com/maps/place/Zabali+Jewelex+Pvt.+limited/@23.0241946,72.5883146,17z/data=!3m1!4b1!4m6!3m5!1s0x395e8518feed87b3:0x16b471c24a06eb96!8m2!3d23.0241946!4d72.5883146!16s%2Fg%2F11lyxthxg8?entry=ttu&g_ep=EgoyMDI1MDMyMy4wIKXMDSoJLDEwMjExNjQwSAFQAw%3D%3D"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ textDecoration: "none", color: "inherit" }}
//           >
//             <p className="num-para">{info}</p>
//           </a>
//         ) : (
//           <p className="num-para">{info}</p>
//         )}
//       </div>
//     </div>
//   );
// };
const ContactInfo = ({ icon, title, info }) => {
  // Check if the title is related to email, phone, WhatsApp, or Address
  const isEmail = title?.toLowerCase().includes("email");
  const isWhatsApp = title?.toLowerCase().includes("whatsapp");
  const isPhone = title?.toLowerCase().includes("call");
  const isAddress = title?.toLowerCase().includes("address");

  const isClickable = isEmail || isWhatsApp || isPhone || isAddress;

  let href = "#";

  if (isEmail) href = `mailto:${info}`;
  else if (isWhatsApp) href = `https://wa.me/${info}`;
  else if (isPhone) href = `tel:${info}`;
  else if (isAddress)
    href =
      "https://www.google.com/maps/place/Zabali+Jewelex+Pvt.+limited/@23.0241946,72.5883146,17z/data=!3m1!4b1!4m6!3m5!1s0x395e8518feed87b3:0x16b471c24a06eb96!8m2!3d23.0241946!4d72.5883146!16s%2Fg%2F11lyxthxg8?entry=ttu&g_ep=EgoyMDI1MDMyMy4wIKXMDSoJLDEwMjExNjQwSAFQAw%3D%3D";

  const CardContent = (
    <div className="inner-card">
      {/* Left side - Icon and Title */}
      <div className="inner-card-left">
        <img src={icon ? icon : Icons.default_image} alt={`${title} icon`} />
        <p className="call-us-para">{title}</p>
      </div>

      {/* Right side - Info */}
      <div className="inner-card-right">
        <p className="num-para">{info}</p>
      </div>
    </div>
  );

  return isClickable ? (
    <a
      href={href}
      target={isEmail || isPhone ? "_self" : "_blank"}
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      {CardContent}
    </a>
  ) : (
    CardContent
  );
};

const ContactUs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const fromContactUsByLoggedInUser =
    location.state?.fromContactUsByLoggedInUser || false;

  const [userOnboardingStatus, setUserOnboardingStatus] = useState("");

  // Define state for form fields
  const [formValues, setFormValues] = useState({
    name: "",
    mobile: "",
    email: "",
    query: "",
  });
  const [errors, setErrors] = useState({});
  const [pageData, setPageData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getPageWithSlugAPI(pageSlug.contactUs, (result) => {
        setPageData(result);
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  const validateContactUsForm = () => {
    const { name, mobile, email, query } = formValues;
    let errors = {};
    let isValid = true;

    if (!name?.trim()) {
      errors.name = "Name is required";
      isValid = false;
    }

    if (!mobile?.trim()) {
      errors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!/^[0-9]{10}$/.test(mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number";
      isValid = false;
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      errors.mobile = "Invalid mobile number";
      isValid = false;
    }

    if (!email?.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
    ) {
      errors.email = "Enter a valid email address";
      isValid = false;
    }

    if (!query?.trim()) {
      errors.query = "Query is required";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  // Handle input changes
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "mobile") {
  //     // Remove any non-numeric characters
  //     const numericValue = value.replace(/\D/g, ""); // Keep only digits
  //     setFormValues((prev) => ({
  //       ...prev,
  //       [name]: numericValue === "" ? null : numericValue,
  //     }));
  //   } else {
  //     setFormValues((prev) => ({
  //       ...prev,
  //       [name]: value === "" ? null : value,
  //     }));
  //   }
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [name]: "",
  //   }));
  // };
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "mobile") {
  //     const numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters

  //     setFormValues((prev) => ({
  //       ...prev,
  //       [name]: numericValue === "" ? null : numericValue,
  //     }));

  //     // Show error if user entered any non-digit character
  //     if (/\D/.test(value)) {
  //       setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         [name]: "Only digits are allowed",
  //       }));
  //     } else if (numericValue.length === 10) {
  //       // Clear error if 10 digits are entered
  //       setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         [name]: "",
  //       }));
  //     }
  //     // Else, do NOT remove existing error (keep it until 10 digits entered)
  //   } else {
  //     setFormValues((prev) => ({
  //       ...prev,
  //       [name]: value === "" ? null : value,
  //     }));

  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       [name]: "",
  //     }));
  //   }
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const numericValue = value.replace(/\D/g, ""); // Only digits

      setFormValues((prev) => ({
        ...prev,
        [name]: numericValue === "" ? null : numericValue,
      }));

      if (/^\d+$/.test(value)) {
        // If input is ONLY digits, clear error
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      } else {
        // If it contains anything other than digits, show error
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Only digits are allowed",
        }));
      }
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value === "" ? null : value,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  // Handle form submission
  const handleSubmit = useCallback(() => {
    if (!validateContactUsForm()) return;
    const { name, mobile, email, query } = formValues;
    const requestData = {
      contact_us_name: name,
      contact_us_mobile_number: mobile,
      contact_us_email: email,
      contact_us_query_text: query,
    };
    try {
      dispatch(
        addContactUsUrl(requestData, (isSuccess, result) => {
          if (result?.status === true) {
            toast.success(result?.message?.message);
            navigate("/home");
            setFormValues(() => ({
              name: "",
              mobile: "",
              email: "",
              query: "",
            }));
          } else {
            toast.error(result?.error);
          }
        })
      );
    } catch (error) {
      toast.error("somethingWentWrongError");
    }
  }, [dispatch, formValues]);

  const { isLoggedIn } = useSelector((state) => state.authSlice);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        if (result?.status) {
          setUserOnboardingStatus(result?.data?.[0]?.user_status_name);
        }
      })
    );
  }, [dispatch, isLoggedIn]);
  return (
    <>
      <div className="contact-us-main-div" style={{ minHeight: "64.6vh" }}>
        <div className="section-1-div" style={{ position: "sticky", top: 0 }}>
          {/* {isLoggedIn && userOnboardingStatus === "approved" ? (
            <Header />
          ) : (
            <HeaderBlack />
          )} */}

          {fromContactUsByLoggedInUser ? (
            <>
              <Header />
            </>
          ) : (
            <>
              <HeaderBlack />
            </>
          )}
        </div>
        {isLoading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : (
          <div className="contact-div">
            <>
              {pageData?.map((e) => {
                return (
                  <div className="contact-card-div">
                    <h2 className="contact-heading-para">{e?.page_name}</h2>
                    <div className="line-div" />
                    {e?.page_json?.[0]?.contact_page_data?.map((ee) => (
                      <div className="contact-inner-cards">
                        <ContactInfo
                          icon={`${BASE_URL}${ee?.contact_icon}`}
                          title={ee?.contact_title}
                          info={ee?.contact_description}
                        />
                      </div>
                    ))}
                  </div>
                );
              })}

              <div className="contact-card-div">
                <h2 className="contact-heading-para">Have a Question?</h2>
                <div className="line-div" />

                <div className="input-fields-div">
                  <div className="inner-inp-field-contact-us">
                    <input
                      className="inpp"
                      type="text"
                      name="name"
                      value={formValues.name}
                      onChange={handleInputChange}
                      placeholder="Enter your name"
                      aria-label="Enter your name"
                    />
                    {errors?.name && (
                      <>
                        <p className="error-mesg-contact-us">{errors?.name}</p>
                      </>
                    )}
                  </div>
                  <div className="inner-inp-field-contact-us">
                    <input
                      className="inpp"
                      type="tel"
                      name="mobile"
                      maxLength={10}
                      value={formValues.mobile || ""}
                      onChange={handleInputChange}
                      placeholder="Enter mobile number"
                      aria-label="Enter mobile number"
                    />{" "}
                    {errors?.mobile && (
                      <>
                        <p className="error-mesg-contact-us">
                          {errors?.mobile}
                        </p>
                      </>
                    )}
                  </div>
                  <div className="inner-inp-field-contact-us">
                    <input
                      className="inpp"
                      type="email"
                      name="email"
                      value={formValues.email}
                      onChange={handleInputChange}
                      placeholder="Enter Email Id"
                      aria-label="Enter email"
                    />{" "}
                    {errors?.email && (
                      <>
                        <p className="error-mesg-contact-us">{errors?.email}</p>
                      </>
                    )}
                  </div>
                  <div className="inner-inp-field-contact-us">
                    <textarea
                      className="inpp"
                      name="query"
                      value={formValues.query}
                      onChange={handleInputChange}
                      placeholder="Enter your query"
                      aria-label="Enter your query"
                    />{" "}
                    {errors?.query && (
                      <>
                        <p className="error-mesg-contact-us">{errors?.query}</p>
                      </>
                    )}
                  </div>
                </div>
                <div className="submit-btn-div" onClick={handleSubmit}>
                  <button>Submit</button>
                </div>
              </div>
            </>
          </div>
        )}
        {!isLoading && <Section4 />}
        {!isLoading && <Footer />}
      </div>
    </>
  );
};

export default ContactUs;
